

import React, { useEffect, useState } from 'react';

import { DashboardLayout, GeneralTable, Button, SubmenuTooltip, MoreButton } from "components";

import { func_validation, getTotalCountFromHeader, isObjectEmpty } from 'functions';
import { tableColumns } from './hooks';

import { useDeleteInvoice, useAlertMessage,
    useUnpostedInvoices, 
    deliveredInvoices, usePendingInvoices 
} from './hooks';

import 'assets/scss/billingPortal/modules/invoices/normalInvoices.scss';
import { MultiFilters } from 'components/filters/MultiFilters';
import { subsidiaryList } from 'constants/lists';



export default function NormalInvoicesPresentation(props) {    
    const {
        invoiceList,
        invoiceListHeaders,
        getInvoiceList_requesting,

        isInvoiceRecordUpdatedSuccessfully,
        history,
        
        sendEmail_requesting,
        postToSQLAccount_requesting,
    } = props;

    // States
    let status = history?.location?.search?.substring("status".length + 2);
    const [currentTabId, setCurrentTabId] = useState(status? status:"unposted");
    const [selectedInvoices, setSelectedInvoices] = useState([]);
    const [isMainActionClicked, setIsMainActionClicked] = useState();
    const [isFilterReset, setIsFilterReset] = useState();
    const [isMounted, setIsMounted] = useState();


    useEffect(() => {
        if (!isMounted) setIsMounted(true);
    }, [isMounted])
    useEffect(() => {
        if (isMounted) setIsFilterReset(true);
    }, [currentTabId]);
    useEffect(() => {
        if (isFilterReset) setIsFilterReset(false);
    }, [isFilterReset]);

    const {
        setAlertMsg,
        alertMsgDisplay
    } = useAlertMessage(props);

    const {
        deleteInvoiceModal,
        setIsModalVisible_deleteInvoice
    } = useDeleteInvoice({
        ...props,
        selectedInvoices, setSelectedInvoices,
        setAlertMsg
    });

    const {
        isExportingFile: isExportingFile_unposted,
        tableActions: tableActions_unposted,
        mainTableActionDetails: mainTableActionDetails_unposted,
        tabDetails: tabDetails_unposted,
        filters: filters_unposted
    } = useUnpostedInvoices({
        ...props,
        selectedInvoices, setSelectedInvoices,
        setIsModalVisible_deleteInvoice,
        setAlertMsg
    });

    const {
        isExportingFile: isExportingFile_pending,
        tableActions: tableActions_pending,
        mainTableActionDetails: mainTableActionDetails_pending,
        tabDetails: tabDetails_pending,
        filters: filters_pending
    } = usePendingInvoices({
        ...props,
        selectedInvoices,
        setIsModalVisible_deleteInvoice,
        setAlertMsg
    });

    const {
        tabDetails: tabDetails_delivered,
        tableActions: tableActions_delivered,
        filters: filters_delivered
    } = deliveredInvoices({
        ...props,
        selectedInvoices,
        setIsModalVisible_deleteInvoice,
    });

    let isMainActionHidden = false;
    let isActionHidden = false;
    let isActionLoading = false;
    let isExportingFile = false;
    let tableActions = [];
    let mainTableActionDetails = {};
    let mainActionText = "";
    let filters = {}
    switch (currentTabId) {
        case "pending":
            isExportingFile = isExportingFile_pending;
            tableActions = tableActions_pending;
            mainTableActionDetails = mainTableActionDetails_pending;
            mainActionText = "Send to Customer";
            filters = filters_pending;
            isActionLoading = sendEmail_requesting;
            break;
        case "delivered":
            isMainActionHidden = true;
            tableActions = tableActions_delivered;
            filters = filters_delivered;
            break;
        default:
            // unposted
            isExportingFile = isExportingFile_unposted;
            tableActions = tableActions_unposted;
            mainTableActionDetails = mainTableActionDetails_unposted;
            mainActionText = "Post Invoices";
            filters = filters_unposted;
            isActionLoading = postToSQLAccount_requesting;
            break;            
    }

    let mainTableActionDetails_onClick = func_validation.getObjectPropertyValue(mainTableActionDetails, "onClick");
    let mainTableActionDetails_isDisabled = func_validation.getObjectPropertyValue(mainTableActionDetails, "isDisabled");
    let mainTableActionDetails_icon = func_validation.getObjectPropertyValue(mainTableActionDetails, "icon");
    let mainTableActionDetails_alt = func_validation.getObjectPropertyValue(mainTableActionDetails, "alt");

    useEffect(() => {
        if (!isActionLoading) setIsMainActionClicked(false);
    }, [isActionLoading]);
    
    let tabsDetails = [tabDetails_unposted, tabDetails_pending, tabDetails_delivered];

    return (
        <div className={"normalInvoices"}>
            <DashboardLayout
                headerTitle={"General Invoices"}

                bodyClassName={"normalInvoices-body"}
                body={(
                    <GeneralTable
                        className={"normalInvoices-table"}
                        columns={tableColumns.getColumns()}
                        data={invoiceList}
                        minRows={10}

                        getTableData={props.getInvoiceList}
                        isTableDataRequestPrevented={isExportingFile}

                        isTableRefreshRequired={isInvoiceRecordUpdatedSuccessfully}

                        onRowSelectionChange={setSelectedInvoices}

                        topOuterTableHeader={() => alertMsgDisplay}
                        outerTableHeader={() => {
                            return (
                                <div className={"normalInvoices-table-header d-flex align-items-center justify-content-between "}>
                                    <div className={"header__title tableHeaderTitle "}>
                                        List
                                    </div>

                                    {isActionHidden? "":(
                                        <div className={"normalInvoices-tableHeader-action d-flex align-items-center"}>
                                            {isMainActionHidden? "":(
                                                <div className={"normalInvoices-tableHeaderAction-mainActionWrapper"}>
                                                    <Button
                                                        className={"normalInvoices-tableHeaderAction-mainAction tableHeaderButtonPadding d-flex align-items-center "}
                                                        handleOnClick={() => {
                                                            mainTableActionDetails_onClick();
                                                            setIsMainActionClicked(true);
                                                        }}

                                                        isLoading={isActionLoading && isMainActionClicked}
                                                        isSpinnerColorPrimary

                                                        isDisabled={mainTableActionDetails_isDisabled}
                                                        isDecoration_primaryTransparent
                                                    >
                                                        <React.Fragment>
                                                            <img
                                                                className={"normalInvoices-tableHeaderAction-icon"}
                                                                src={mainTableActionDetails_icon}
                                                                alt={mainTableActionDetails_alt}
                                                            />

                                                            <span className={"normalInvoices-tableHeaderAction-text tableHeaderButtonText "}>{mainActionText}</span>
                                                        </React.Fragment>
                                                    </Button>
                                                </div>
                                            )}

                                            <SubmenuTooltip
                                                buttonClassName={""}
                                                menuItems={tableActions}
                                            >
                                                <MoreButton
                                                    className={"normalInvoices-tableHeaderAction-moreActions"}
                                                    iconClassName={"normalInvoices-tableHeaderMoreAction-icon"}
                                                />
                                            </SubmenuTooltip>
                                        </div>
                                    )}
                                </div>
                            );
                        }}

                        bottomOuterTableHeader={(outerTableHeader_props) => {
                            const {
                                filterOptions, setFilterOptions
                            } = outerTableHeader_props;

                            return (
                                <div className={"table__table-filter d-flex flex-wrap align-items-center"}>
                                    <MultiFilters
                                        defaultFilterOption={{
                                            label: "Invoice ID", 
                                            propertyName: "id",
                                            placeholder: "Invoice ID",
                                            inputType: "search",
                                        }}
                                        filterOptions={[
                                            {
                                                label: "Invoice ID", 
                                                propertyName: "id",
                                                placeholder: "Invoice ID",
                                                inputType: "search",
                                            },
                                            {
                                                label: "Reference Doc. No.", 
                                                propertyName: "documentNo",
                                                placeholder: "Reference Document No.",
                                                inputType: "search",
                                            },
                                            {
                                                label: "Account Code", 
                                                propertyName: "accountCode",
                                                placeholder: "Account Code",
                                                inputType: "search"
                                            },
                                            {
                                                label: "Issue Date", 
                                                propertyName: "issueDateTime",
                                                placeholder: "Issue Date",
                                                inputType: "date"
                                            },
                                            {
                                                label: "Document Date", 
                                                propertyName: "docDate",
                                                placeholder: "Document Date",
                                                inputType: "date"
                                            },
                                            {
                                                label: "Subsidiary", 
                                                propertyName: "subsidiary",
                                                placeholder: "Subsidiary",
                                                options: [{ label: "All", value: "" }].concat(subsidiaryList),
                                                inputType: "dropdown"
                                            }
                                        ]}
                                        dropdownPlaceholder={"Select Filter"}
                                        onApplyFilter={(inputFilters) => {
                                            // find matched tab
                                            let defaultFilter = {}
                                            tabsDetails.map((tabObj, idx) => {
                                                if (tabObj?.id === currentTabId) {
                                                    defaultFilter = tabObj?.filters? tabObj?.filters: filters;
                                                }
                                            })
                                            setFilterOptions(isObjectEmpty(inputFilters)? defaultFilter: { ...filterOptions, ...inputFilters});
                                        }}
                                        isResetFromParentRequired={isFilterReset}
                                    />
                                </div>
                            );
                        }}

                        tabsDetails={tabsDetails}
                        onTabIdChange={setCurrentTabId}
                        defaultTabId={currentTabId}
                        defaultFilter={filters}
                        isTabRequired

                        isExpanderRequired

                        isTableDataLoading={getInvoiceList_requesting && !isExportingFile}

                        isUsingPagination
                        totalRecords={getTotalCountFromHeader(invoiceListHeaders)}

                        isColumnResizeable isAllColumnWidthEqual
                        isTableOddRowsDarken
                        isCheckboxRequired
                        isCheckboxColumnFirst
                    />
                )}
            />

            {/* Delete Alert */}
            {deleteInvoiceModal}
        </div>
    );
}